import React, { useEffect, useState } from 'react';
import { superAdminAPI } from '../../lib/walletApi';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Loader2, FileSpreadsheet, ArrowLeftRight } from 'lucide-react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

const COLORS = ['#EC4899', '#8B5CF6', '#3B82F6', '#10B981', '#F59E0B'];

export default function SuperAdminReports() {
  const [payroll, setPayroll] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try { const [p, t] = await Promise.all([superAdminAPI.getPayrollReport({}), superAdminAPI.getTransactionReport({})]); setPayroll(p); setTransactions(t); }
      catch (e) { console.error(e); } finally { setLoading(false); }
    }; load();
  }, []);

  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;

  const statusData = payroll?.by_status ? Object.entries(payroll.by_status).map(([k, v]) => ({ name: k, value: v })) : [];

  return (
    <div className="space-y-6" data-testid="sa-reports">
      <div><h1 className="text-xl font-bold text-gray-900">Platform Reports</h1><p className="text-sm text-gray-500">Payroll and transaction analytics</p></div>
      <div className="grid lg:grid-cols-2 gap-4">
        <Card className="border-gray-200 shadow-sm">
          <CardHeader className="pb-2"><CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2"><FileSpreadsheet className="w-4 h-4 text-pink-500" /> Payroll Summary</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-3 gap-3">
              {[{ l: 'Runs', v: payroll?.total_runs || 0 }, { l: 'Gross', v: `NGN ${Number(payroll?.total_gross || 0).toLocaleString()}` }, { l: 'Net', v: `NGN ${Number(payroll?.total_net || 0).toLocaleString()}` }].map(s => (
                <div key={s.l} className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">{s.l}</p><p className="text-sm font-bold text-gray-900">{s.v}</p></div>
              ))}
            </div>
            {statusData.length > 0 && <div className="h-40 mt-4"><ResponsiveContainer><PieChart><Pie data={statusData} cx="50%" cy="50%" innerRadius={35} outerRadius={55} dataKey="value">{statusData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Tooltip /></PieChart></ResponsiveContainer></div>}
          </CardContent>
        </Card>
        <Card className="border-gray-200 shadow-sm">
          <CardHeader className="pb-2"><CardTitle className="text-sm font-semibold text-gray-700 flex items-center gap-2"><ArrowLeftRight className="w-4 h-4 text-blue-500" /> Transactions</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Total</p><p className="text-sm font-bold text-gray-900">{transactions?.total_transactions || 0}</p></div>
              <div className="bg-gray-50 rounded-xl p-3"><p className="text-[10px] text-gray-500 uppercase">Volume</p><p className="text-sm font-bold text-gray-900">NGN {Number(transactions?.total_volume || 0).toLocaleString()}</p></div>
            </div>
            {transactions?.by_type && Object.keys(transactions.by_type).length > 0 && (
              <div className="mt-4 space-y-2">{Object.entries(transactions.by_type).map(([type, data]) => (
                <div key={type} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
                  <span className="text-xs text-gray-600">{type.replace(/_/g, ' ')}</span>
                  <span className="text-xs font-medium text-gray-900">{data.count} / NGN {Number(data.volume).toLocaleString()}</span>
                </div>
              ))}</div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
